import React from 'react';
import { ListColumnType } from 'types/ListTypes';
import AbstractList from 'components/lists/AbstractList';
import { useSettingsDivision } from 'components/settings/SettingsDivisionContext';
import OrderPdfLayoutForm from './OrderPdfLayoutForm';

// Rename the name of the function:
const OrderPdfLayoutList: React.FC = () => {

    // Filter the list on the division selected in the settings menu
    const { selectedDivision, isEnvironmentSelected } = useSettingsDivision();
    const divisionParams = !isEnvironmentSelected && selectedDivision ? { 'division_scope': selectedDivision.id } : {};

    // Specify the options of this list:
    const query = {
        endpoint: 'get_layout_for_feature_list/order',
        defaultParams: { ...divisionParams },
        object: 'layout'
    }
    const objectName = 'layout.general.object_name'
    const showSearch = false
    const showDeleteOrDeactivate = 'flag_deleted'
    const isDraggable = true
    const draggingApiUrl = 'patch_layout_ordering/order'

    // Set isPaginated to true if this list may have 100.000+ items:
    const isPaginated = false

    // Specify form, detail modal or detailpage for this list
    const formModal = <OrderPdfLayoutForm />;
    const onRowClick = 'detailPage'
    const detailPageUrl = 'settings/templates/layout/pdf-layout'

    // Specify the columns of this list:
    const columns: ListColumnType[] = [
        { width: '1fr', field: 'name', label: 'layout.general.name_label' },
    ];

    return (
        <AbstractList
            key={!isEnvironmentSelected && selectedDivision ? selectedDivision.id : 'environment'}
            query={query}
            objectName={objectName}
            columns={columns}
            showSearch={showSearch}
            showDeleteOrDeactivate={showDeleteOrDeactivate}
            formModal={formModal}
            isPaginated={isPaginated}
            onRowClick={onRowClick}
            detailPageUrl={detailPageUrl}
            isDraggable={isDraggable}
            draggingApiUrl={draggingApiUrl}
        />
    );
};

export default OrderPdfLayoutList;